import { CountUp } from "@/components/CountUp";
import { Users, ScrollText, Building2, Flag } from "lucide-react";

export function StatsBar({ stats, dark = false }) {
  const items = [
    { key: "total_doctors", label: "Doctors", value: stats?.total_doctors ?? 0, Icon: Users },
    { key: "total_pledges", label: "Pledges", value: stats?.total_pledges ?? 0, Icon: ScrollText },
    { key: "cities_count", label: "Cities", value: stats?.cities_count ?? 0, Icon: Building2 },
    { key: "states_count", label: "States / UTs", value: stats?.states_count ?? 0, Icon: Flag },
  ];
  return (
    <div data-testid="stats-bar" className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map(({ key, label, value, Icon }) => (
        <div
          key={key}
          data-testid={`stat-${key}`}
          className={`rounded-2xl p-6 border transition-colors ${
            dark
              ? "bg-white/5 border-white/10"
              : "bg-white border-slate-200 hover:border-[#0056D2]/40"
          }`}
        >
          <div className="flex items-center gap-2 mb-3">
            <Icon className={`w-5 h-5 ${dark ? "text-[#FF9933]" : "text-[#0056D2]"}`} />
            <span className={`text-xs uppercase tracking-[0.2em] font-semibold ${dark ? "text-slate-400" : "text-slate-500"}`}>
              {label}
            </span>
          </div>
          <CountUp
            value={value}
            className={`font-display font-extrabold tabular-nums ${
              dark ? "text-white text-5xl lg:text-6xl" : "text-slate-900 text-4xl lg:text-5xl"
            }`}
          />
        </div>
      ))}
    </div>
  );
}
